import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, SimpleEvent } from '@eastsideco/salvo-ts';

import './BodyOverlay.scss';

@Component
export class BodyOverlay extends ThemeComponent {
    private close: string = '';
    private _onCloseChange = new SimpleEvent<string>();

    public get onCloseChange() {
        return this._onCloseChange.asEvent();
    }

    init() {
        this.$listen(this, 'click', () => {
            this._onCloseChange.dispatch(this.close);
            this.closeOverlay();
        });
    }

    public openOverlay() {
        this.classList.remove('visibility-hidden');
    }

    public closeOverlay() {
        this.classList.add('visibility-hidden');
    }
}
